import { render, staticRenderFns } from "./pill-v2.vue?vue&type=template&id=ded6de46&"
import script from "./pill-v2.vue?vue&type=script&lang=ts&"
export * from "./pill-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports